import API from "../../common/utils/API";
import {activityLoggerActionTypes, approvalsActionTypes} from "../veritas-middleware/constants/UtilityMiddlewareConstants";
import {updatedDPRefresh} from "../../veritas/add-edit/actions/AddEditDPActions";
import {updatedDPServiceRefresh} from "../../veritas/add-edit/actions/AddEditDPServiceActions";
import {updatedDPSourceRefresh} from "../../veritas/add-edit/actions/AddEditDPSourceActions";

/**
 * This is the approvals middleware. Only a DPAdmin is able to get to this point. This
 * middleware, sets / resets the approval on a resource. The type of resource is
 * specified in the parameters and accordingly is refreshed on the front-end.
 * This is followed by an action dispatch to logger middleware which takes the object_id, object_type and user
 * and logs it as a change.
 * @param store
 * @returns {function(*): function(...[*]=)}
 */
const approvalsMiddleware = (store) => (next) => (action) => {

    switch (action.type) {

        case approvalsActionTypes.SET_APPROVAL: {
            next(action);

            const {type, approvalsObject, authToken} = action.payload;
            approvalsObject.approved_by = authToken.account.name;

            return API.setApproval(approvalsObject, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: approvalsObject.resource_id,
                        object_type: `${type}_approved`,
                        user: authToken.account.name
                    }
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    switch (type) {
                        case 'dp': {
                            store.dispatch(updatedDPRefresh());
                            return;
                        }
                        case 'dpService': {
                            store.dispatch(updatedDPServiceRefresh());
                            return;
                        }
                        case 'dpSource': {
                            store.dispatch(updatedDPSourceRefresh());
                            return;
                        }

                        default:
                            console.error("Wrong Action Dispatched!");
                            return;
                    }
                })
                .catch(err => console.log(err));
        }

        case approvalsActionTypes.REMOVE_APPROVAL: {
            next(action);

            const {type, approvalsObject, authToken} = action.payload;

            return API.clearApprovalData(approvalsObject, authToken.idToken)
                .then(res => {
                    const log = {
                        object_id: approvalsObject.resource_id,
                        object_type: `${type}_not_approved`,
                        user: authToken.account.name
                    }
                    store.dispatch({
                        type: activityLoggerActionTypes.LOG_CHANGE,
                        payload: {log, authToken}
                    });
                    switch (type) {
                        case 'dpSource': {
                            store.dispatch(updatedDPSourceRefresh());
                            return;
                        }
                        case 'dp': {
                            store.dispatch(updatedDPRefresh());
                            return;
                        }
                        case 'dpService': {
                            store.dispatch(updatedDPServiceRefresh());
                            return;
                        }

                        default:
                            console.error("Wrong Action Dispatched!");
                            return;
                    }
                })
                .catch(err => console.log(err));
        }

        default: next(action);
    }
}

export default approvalsMiddleware;
